export default "__VITE_ASSET__BtuKjSws__"